import React from 'react';
import { ImageIcon, Plus, Filter, MoreVertical, Download } from 'lucide-react';
export function GalleryView() {
  const images = [{
    id: 1,
    title: 'Signature Dish - Salmon',
    date: 'May 28, 2026',
    url: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?auto=format&fit=crop&q=80&w=800'
  }, {
    id: 2,
    title: 'Main Dining Room',
    date: 'May 25, 2026',
    url: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&q=80&w=800'
  }, {
    id: 3,
    title: 'Kitchen Team',
    date: 'May 20, 2026',
    url: 'https://images.unsplash.com/photo-1556910103-1c02745a3095?auto=format&fit=crop&q=80&w=800'
  }, {
    id: 4,
    title: 'Wine Cellar',
    date: 'May 15, 2026',
    url: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?auto=format&fit=crop&q=80&w=800'
  }, {
    id: 5,
    title: 'Outdoor Patio',
    date: 'May 10, 2026',
    url: 'https://images.unsplash.com/photo-1515003197210-e0cd71810b5f?auto=format&fit=crop&q=80&w=800'
  }, {
    id: 6,
    title: 'Dessert Special',
    date: 'May 05, 2026',
    url: 'https://images.unsplash.com/photo-1551024601-bec78aea704b?auto=format&fit=crop&q=80&w=800'
  }];
  return <div className="space-y-6" data-id="element-195">
      <div className="flex items-center justify-between" data-id="element-196">
        <div data-id="element-197">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-198">Gallery</h2>
          <p className="text-sm text-slate-500" data-id="element-199">
            Visual assets and restaurant photography
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-200">
          <button className="p-2 text-slate-400 hover:text-slate-600 hover:bg-white rounded-xl border border-transparent hover:border-slate-200 transition-all" data-id="element-201">
            <Filter size={20} data-id="element-202" />
          </button>
          <button className="flex items-center gap-2 px-6 py-2 bg-emerald-500 text-white rounded-xl text-sm font-bold shadow-lg shadow-emerald-500/20 hover:bg-emerald-600 transition-all" data-id="element-203">
            <Plus size={16} data-id="element-204" />
            Upload Photo
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-205">
        {images.map(img => <div key={img.id} className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden group" data-id="element-206">
            <div className="aspect-video relative overflow-hidden" data-id="element-207">
              <img src={img.url} alt={img.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-208" />
              <div className="absolute inset-0 bg-slate-900/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2" data-id="element-209">
                <button className="p-2 bg-white rounded-lg text-slate-900 hover:bg-emerald-500 hover:text-white transition-colors" data-id="element-210">
                  <Download size={18} data-id="element-211" />
                </button>
                <button className="p-2 bg-white rounded-lg text-slate-900 hover:bg-emerald-500 hover:text-white transition-colors" data-id="element-212">
                  <MoreVertical size={18} data-id="element-213" />
                </button>
              </div>
            </div>
            <div className="p-4" data-id="element-214">
              <h4 className="text-sm font-bold text-slate-900 mb-1" data-id="element-215">
                {img.title}
              </h4>
              <p className="text-[10px] text-slate-400 font-medium" data-id="element-216">
                {img.date}
              </p>
            </div>
          </div>)}
      </div>
    </div>;
}